// ログイン後の行き先（portal.md「ログイン（ポータル自身）」）。
// 所属が 1 つ（system-admin でない）ならその契約の TOP、それ以外は契約選択画面。
// active でない所属（無効化・受諾前）は無いものとして数える（選べない契約へ自動で入らない）。

import type { Me, MeMembership } from "./api";

/** 選べる所属。active でない所属は選択画面に出さず、その契約にも入れない。 */
export const selectableMemberships = (me: Pick<Me, "memberships">): MeMembership[] =>
  me.memberships.filter((m) => m.status === "active");

/**
 * 招待のリンクからのログインで、参加したことを示す契約名。契約選択画面へ行くとき（他にも所属がある・
 * system-admin）だけ返す。その契約の TOP へ直接入るなら示さない。有効化されていなければ（期限切れ等）示さない。
 */
export function joinedContractName(me: Pick<Me, "platformRole" | "memberships">, invitedContractId: string | undefined): string | null {
  if (!invitedContractId || landingPath(me) !== "/select") return null;
  return selectableMemberships(me).find((m) => m.contract.contractId === invitedContractId)?.contract.name ?? null;
}

export function landingPath(me: Pick<Me, "platformRole" | "memberships">): string {
  const memberships = selectableMemberships(me);
  if (me.platformRole !== "system-admin" && memberships.length === 1) {
    return `/c/${memberships[0].contract.contractId}`;
  }
  return "/select";
}
